import { Button, ButtonProps } from 'antd'
import React from 'react'
import { styled } from 'styled-components'
import { DesignSystem } from '~/core/designSystem'
import { FeatureChatV3 } from '~/features/chatV3/client'

const Wrapper = styled(Button)`
  background: ${DesignSystem.ThemeConst.PRIMARY_YELLOW};
  border-color: ${DesignSystem.ThemeConst.PRIMARY_YELLOW};
  color: black;
  font-weight: 500;

  &:hover {
    background: ${DesignSystem.ThemeConst.PRIMARY_YELLOW} !important;
    border-color: black !important;
  }
`

type Props = ButtonProps

export const ButtonCTA: React.FC<Props> = ({ loading, children, ...props }) => {
  return (
    <Wrapper
      size="large"
      variant="outlined"
      block
      {...props}
      loading={
        loading
          ? {
              icon: <FeatureChatV3.LoaderDots />,
            }
          : undefined
      }
    >
      {children}
    </Wrapper>
  )
}
